import { Column, Row, Text } from "@amzn/meridian";
import React from "react";
import { COLORS } from "src/constants/colors";
import { AI, MANUAL_OVERRIDE } from "src/constants/constants";
type ResultDisplayCardProps = {
  questionText: string;
  evidenceUrl: string;
  questionIndex: number;
  isCompliant: boolean;
  isInspectorOverride: boolean;
};
const ResultDisplayCard = ({
  questionText,
  evidenceUrl,
  questionIndex,
  isCompliant,
  isInspectorOverride,
}: ResultDisplayCardProps) => {
  return (
    <Column backgroundColor={COLORS.WHITE}>
      <Row widths={["fill", "fit"]} spacing={"none"}>
        <Column spacingInset={"300"}>
          <Row alignmentVertical="top">
            <Text type="h50">{`${questionIndex + 1}.`}</Text>
            <Column spacing={"300"}>
              <Row alignmentVertical="top">
                <Text type="b200">{questionText}</Text>
              </Row>
              <Row>
                <Text color={isCompliant ? "success" : "error"} type="h50">
                  {isCompliant ? "Yes" : "No"}
                </Text>
                <Row
                  spacingInset={"none 400"}
                  backgroundColor={
                    isInspectorOverride
                      ? COLORS.AI_RESULT_OVERRIDE_COLOR
                      : COLORS.AI_RESULT_ACCEPTED_COLOR
                  }
                >
                  <Text
                    type="h50"
                    color={isInspectorOverride ? "primary" : "inverted"}
                  >
                    {isInspectorOverride ? MANUAL_OVERRIDE : AI}
                  </Text>
                </Row>
              </Row>
            </Column>
          </Row>
        </Column>
        <Column
          backgroundColor="green"
          alignmentVertical="justify"
          height={"100%"}
          width={69}
        >
          <img src={evidenceUrl} style={{ height: "100%", width: "100%" }} />
        </Column>
      </Row>
    </Column>
  );
};

export default ResultDisplayCard;
